import { UserInfoType } from '@/interface/KKC';
import { NewUserActivityInfo } from '@/interface/pub';
import * as Sentry from '@sentry/react';
import request, { Options } from '@web/common/src/utils/requests/request';
import { ClInterestRateRange } from './interface/CL/clCredit';
import { BoolString } from './interface/KKC/withdrawal';

// 获取用户信息

export const getUserInfoApi = (options?: Options) =>
  request.post<UserInfoType>('/user/getUserInfo', null, options).then((res) => {
    Sentry.setUser({
      id: res.userId,
      username: res.userName,
    });
    const scope = Sentry.getCurrentScope();
    scope.setUser({
      id: res.userId,
      username: res.userName,
    });
    return res;
  });

// 判断是否是真实通过Ekyc，当身份证和人脸匹配通过 ||  匹配不通过但是 Ekyc审批通过了，则返回 Y；否则是 N
export const queryRealEkyc = () =>
  request.post<{
    isRealEkycApproval: BoolString; // 是否通过Ekyc Y 是 N 否
    isPayNewFlow: BoolString; // 是否走提现新流程 Y 是 N 否
  }>('credit/clCredit/queryRealEkyc');

// 授信流程退出时调用的接口
export const processExitRecord = () =>
  request.post('/credit/apply/processExitRecord', null, { loading: true });

// CL 授信流程退出时调用的接口
export const clProcessExitRecord = () =>
  request.post('/credit/apply/clProcessExitRecord', null, { loading: true, isIntercept: false });

export const commonConfig = (keys: string) =>
  request.post<{
    configs: {
      [key: string]: string;
    };
  }>('/credit/nl/common/config', { keys });

export const queryClAvaliable = (userId: string) =>
  request.get<BoolString>(`credit/approve/cl/WhiteList/${userId}`);

// 查詢用戶是否白名單
export const queryUserAvaliable = (userId: string, type: string) =>
  request.get<BoolString>(`credit/approve/whiteList/${userId}/${type}`);

// Facebook CAPI
export const trackFacebookCapi = (params: any) =>
  request.post<BoolString>('/credit/nl/common/faceBookApi', params);

// 获取AbTest结果 - 根据场景和用户ID
export const commonABtest = (bizId: string, scene: string) =>
  request.get<{ bizId: string; scene: string; env: string }>(
    `/credit/nl/common/abtest/user/env/${bizId}/${scene}`
  );

// 查詢公司配置
export const queryComConfig = () => request.get(`credit/layout-data/query-statement-info`);

// 查詢產品配置
export const queryProductConfig = (productCode?: string) =>
  request.get<ClInterestRateRange>(
    `credit/nl/common/query-product-info?productCode=${productCode}`
  );
// 获取oss上传key
export const generationkey = () => request.get(`/system/oss/generation/key/upload/06`);

// 新客限時優惠活動進度查詢
export const queryNewUserProgress = (params: {
  userId: string;
  creditPassFlag?: BoolString;
  creditApplyId?: string;
}) => request.post<NewUserActivityInfo>(`/credit/new-activity/query-new-customer-progress`, params);

// 查詢用戶是否統一還款日白名單
export const queryUserUnionLoanAvaliable = () =>
  request.get<{ enabled: BoolString }>(`credit/pay/getUniformRepaymentDateWhiteList`);

// TU重定向
export interface TURedirectResponse {
  redirectUrl: string;
  encryptedData: string;
  formHtml: string;
}

export const generateTURedirect = (
  userId: string,
  src: 'W' | 'A',
  entranceCode: string,
  lang: string
) =>
  request.post<TURedirectResponse>('credit/app/creditview/generate-redirect', {
    userId,
    src,
    entranceCode,
    lang,
  });

export interface LastedRecordResponse {
  canQuery: 'Y' | 'N';
  [key: string]: any;
}

export const queryLastedRecord = () =>
  request.get<LastedRecordResponse>('credit/app/creditview/record/queryLastedRecord', null, {
    loading: true,
  });

export const getEkycState = () =>
  request.post<{
    ekycLockEnd: string; // ekyc禁申截止日期
    ekycType: string; // ekyc类型
    isNeedEkyc: string; // 是否需要ekyc弹窗
    isPass: string; // ekyc是否通过
    message: string; // 文案提示
  }>('credit/apply/ekyc/state');

// bycursor-start
/**
 * 解析报告请求响应结构
 * @author bycursor
 */
export interface ParseReportRequestResponse {
  fileKey: string;
}

/**
 * 解析报告结果响应结构
 * @author bycursor
 */
export interface ParseResultResponse {
  fileKey: string;
  status: 'IN_PROGRESS' | 'SUCCESS' | 'FAIL';
  errorMessage: string;
}

/**
 * 请求解析信贷报告
 * @author bycursor
 * @param filePath OSS文件路径
 * @returns 返回 fileKey
 */
export const parseReportRequest = (filePath: string) =>
  request.post<ParseReportRequestResponse>('credit/creditview-report/parse-report-request', {
    filePath,
  });

/**
 * 查询报告解析结果
 * @author bycursor
 * @param params.fileKey 文件标识
 * @returns 返回解析状态和结果
 */
export const parseResult = (params: { fileKey: string }) =>
  request.post<ParseResultResponse>('credit/creditview-report/parse-result', params);
// bycursor-end
// Contains cursor-generated edits.

export const queryPageState = () => request.get('credit/creditview-report/page-state');
